module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info_box",
    class: _vm.getColorClass(_vm.event.tid, _vm.event.parents_id)
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._v(_vm._s(_vm.event.longtitle))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "see_more"
  }, [_vm._v(_vm._s(_vm.event.description) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.eventDate))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.event.datetime))]), _vm._v(" "), _c('a', {
    staticClass: "see_more",
    attrs: {
      "href": _vm.event.event_url
    }
  }, [_vm._v("See more")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5796cad0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventHover.vue
// module id = 566
// module chunks = 1